var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"dashboardContainer"}},[_c('div',{attrs:{"id":"topArea"}},[_vm._v("뮤앤무 관리자 페이지")]),_c('div',{attrs:{"id":"middleWrapper"}},[_c('left-menu'),_c('div',{attrs:{"id":"mainContent"}},[_c('router-view')],1)],1),_c('top-toast-message'),_c('spinner')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }